import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';

import {HttpService} from '../service/http-service';

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {

  constructor(private router: Router, private httpService: HttpService) {
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    // return true;
    if (sessionStorage.getItem('token') !== null && sessionStorage.getItem('token') !== '') {
      return true;
    }
    this.httpService.showSnackBar('error', 'Please Login To Your Account !!!');
    this.router.navigate(['/authentication/login']);
    sessionStorage.clear();
    return false;
  }

}
